import Resource from './Resource'

/**
 * Comment Resource
 */
class Comment extends Resource
{
    constructor() {
        super('comment', ['comments']);
    }
}   

export let CommentResource = new Comment();

/**
 * CommentSchema
 * @param {Object} defaults [description]
 */
export let CommentSchema = function(defaults = {}) {
    let schema = {
        id: null,
        content: null, 
        owner_id: null,
        owner_type: null,
        created_by_id: null, 
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
}